// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0e831a52] .toolbar {\n  position: relative;\n  z-index: 10001;\n}\n", ""]);
// Exports
module.exports = exports;
